import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'app-payment-tab',
    templateUrl: './payment-tab.component.html',
    styleUrls: ['./payment-tab.component.scss']
})
export class PaymentTabComponent implements OnInit {
    @Input() formGroupName: string = 'paymentData';

    constructor(private rootForm: FormGroupDirective) {}

    form: FormGroup = new FormGroup({});

    ngOnInit() {
        this.form = this.rootForm.control.get(this.formGroupName) as FormGroup;
    }
}
